import { render, staticRenderFns } from "./InsightEdit.vue?vue&type=template&id=041aba74&scoped=true&"
import script from "./InsightEdit.vue?vue&type=script&lang=ts&"
export * from "./InsightEdit.vue?vue&type=script&lang=ts&"
import style0 from "./InsightEdit.vue?vue&type=style&index=0&id=041aba74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041aba74",
  null
  
)

export default component.exports